module.exports = __webpack_public_path__ + "images/candidate-survey-e2c8f9a7eb655f9808754cbe34df3844.png";